module.exports = __webpack_public_path__ + "static/media/parking5.d155d214.webp";